import { namespace } from 'vuex-class';
import { IImporterState } from './importer.types';

export const Importer = namespace('documentManipulator/createPage/importer');

export enum EImporterAction {
  PrepareImport = 'prepareImport',

  ImportTemplate = 'importTemplate',

  ImportWordDocument = 'importWordDocument',
  ProcessWordDocument = 'processWordDocument',
  SetWordMergeProperties = 'setWordMergeProperties',
  SaveWordMergeDynamicTemplate = 'saveWordMergeDynamicTemplate',

  ImportFiles = 'importFiles',
  StartLoadingPages = 'startLoadingPages',
  LoadPage = 'loadPage',
  CompleteFileImport = 'completeFileImport',

  ImportGoogleDrive = 'importGoogleDrive',

  ImportFailed = 'importFailed',
  ImportSuccess = 'importSuccess',
  Reset = 'reset',
}

export enum EImporterMutation {
  SetImporting = 'setImporting',
  SetImported = 'setImported',
  SetError = 'setError',
  SetImportData = 'setImportData',
  SetFileImportProperties = 'setFileImportProperties',
  SetImportedPages = 'setImportedPages',
  SetImportedDocument = 'setImportedDocument',
  SetState = 'setState',
  SetImportStage = 'setImportStage',
  SetWordMerge = 'setWordMerge',
}

export enum EImporterGetter {
  Progress = 'progress',
  ShowWordMergeModal = 'showWordMergeModal',
}

export const state: IImporterState = {
  imported: false,
  importing: false,
  importedDocument: null,
  importedPages: [],
  importData: {
    title: null,
    type: null,
    error: null,
    stage: null,
  },
  wordMerge: {
    filename: '',
    isDynamic: true,
    missing: [],
    index: 0,
  },
  fileImport: {
    pageCount: 0,
    fileCount: 0,
    recievedFileImportCount: 0,
  },
};
